import CompanyBanner from "../../components/sections/front/CompanyBanner";
import CompanySection from "../../components/sections/front/CompanySection";
import HomeBanner from "../../components/sections/front/HomeBanner";
import JobSection from "../../components/sections/front/JobSection";

const Companies = () => {
  return (
    <>
      <CompanyBanner />
      <CompanySection />
    </>
  );
};

export default Companies;
